/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QueuedAssetProgressResponse { 
    Id?: string;
    ClusterId?: string;
    ConnectionId?: number;
    PortfolioId?: string | null;
    ModifiedFrom?: string;
    ModifiedUntil?: string;
    QueuedDate?: string | null;
    SendDate?: string | null;
}

